import { Card, Stack, Typography } from '@mui/material';

import { Icon } from '@/components/atoms/Icon/Icon';
import type { Icons } from '@/components/atoms/Icon/icons';
import { BottomSheetDialog } from '@/pwa/atoms/BottomSheetDialog/BottomSheetDialog';

export interface AccountSheetProps {
  isOpen: boolean;
  /** Named in the sheet, so a wrong account is visible. */
  email?: string;
  onClose: () => void;
  onSignOut: () => void;
  onHelp: () => void;
}

const TITLE = 'Settings';

const Row = ({
  icon,
  label,
  onClick,
}: {
  icon: Icons;
  label: string;
  onClick: () => void;
}) => (
  <Card
    component='button'
    type='button'
    variant='option'
    onClick={onClick}
    sx={{ width: '100%', textAlign: 'left' }}
  >
    <Stack direction='row' spacing={1.5} sx={{ alignItems: 'center' }}>
      <Icon icon={icon} fontSize={18} />
      <Typography variant='h6'>{label}</Typography>
    </Stack>
  </Card>
);

/** AccountSheet is what the avatar in the onboarding app bar opens. */
export const AccountSheet = ({
  isOpen,
  email,
  onClose,
  onSignOut,
  onHelp,
}: AccountSheetProps) => {
  const choose = (action: () => void) => () => {
    onClose();
    action();
  };

  return (
    <BottomSheetDialog isOpen={isOpen} onClose={onClose} title={TITLE}>
      <Stack spacing={1} sx={{ pb: 2 }}>
        <Row icon='circle-question' label='Help' onClick={choose(onHelp)} />
        <Row
          icon='arrow-right-from-bracket'
          label='Sign out'
          onClick={choose(onSignOut)}
        />
        {email && (
          <Typography
            variant='caption'
            sx={{ textAlign: 'center', color: 'text.secondary' }}
          >
            You&rsquo;re currently signed in with {email}
          </Typography>
        )}
      </Stack>
    </BottomSheetDialog>
  );
};

AccountSheet.displayName = 'AccountSheet';
export default AccountSheet;
